var _excluded = ["width", "theme", "className", "data-qa"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import Icon from "@components/icon";
import { joinCn } from "@ati/uti";
import styles from "./Preloader.module.scss";
var Preloader = _ref => {
  var {
      width = 30,
      theme = "dark",
      className,
      "data-qa": dataQa = "preloader"
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      width,
      height: width
    }
  }, props, {
    "data-qa": dataQa,
    className: joinCn(styles.preloader, className)
  }), /*#__PURE__*/React.createElement(Icon, {
    className: styles["preloader-icon"],
    name: "ic_preloader",
    color: theme === "light" ? "#fff" : "#B8B8B8",
    width: width,
    height: width
  }));
};
export default Preloader;